import {LeadWatcherChangeNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";

/**
 * Lead watcher change notification class data.
 */
export default class LeadWatcherChangeNotificationData {
	/**
	 *
	 * @param {string} leadId
	 * @param {string} referenceNumber
	 * @param {string} creator
	 * @param {string[]} previousWatchersIds
	 * @param {string[]} currentWatchersIds
	 */
	constructor(readonly leadId: string,
		readonly referenceNumber: string,
		readonly creator: AuthenticatedEntity,
		readonly previousWatchersIds: string[],
		readonly currentWatchersIds: string[]) {}

	static fromJson(json: LeadWatcherChangeNotificationDataApiDto): LeadWatcherChangeNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new LeadWatcherChangeNotificationData(json.leadId, json.referenceNumber, creator, json.previousWatchers, json.currentWatchers);
	}

	getLeadReferenceNumber() {
		return this.referenceNumber;
	}
}
